import moment from 'moment';

import { oneOf } from '@philips-emr/tws-core/lib/component/prop-types';
import { Formatter, registerFormatter, Validation } from '@philips-emr/tws-core/lib/services/model-service';

import { DateFormatterOptions } from './date-types';
import { createMask, DATE_FORMATS, getDateFormat, getPattern as getPatternUtil, isValid, toDate } from './date-utils';

export function format(value: any, options: DateFormatterOptions = {}): string {
  const { type = 'date' } = options;
  const { parseFormat } = getDateFormat(type);

  const masked = createMask(options);

  if (isValid(value, parseFormat)) {
    masked.typedValue = toDate(value, parseFormat);
  } else {
    masked.unmaskedValue = String(value);
  }

  return masked.value || value;
}

format.optionTypes = {
  type: oneOf(['', ...Object.keys(DATE_FORMATS)]),
};

export function parse(value: any, options: DateFormatterOptions = {}): string {
  const { type = 'date' } = options;
  const { format, parseFormat } = getDateFormat(type);
  const masked = createMask(options);

  masked.value = String(value);

  if (masked.isComplete) {
    const date = moment(masked.unmaskedValue, format).utc();

    return date.isValid()
      ? date.format(parseFormat)
      : masked.unmaskedValue;
  }

  return masked.unmaskedValue;
}

export function validate(value: any, options: DateFormatterOptions = {}): Validation[] {
  if (!value) {
    return [{ name, valid: true }];
  }

  const { type = 'date' } = options;
  const { parseFormat } = getDateFormat(type);

  const valid = isValid(value, parseFormat);

  return [{
    name,
    valid,
    message: !valid ? 'tws.validator.invalid-date' : '',
  }];
}

export function getPattern(options: DateFormatterOptions = {}): string {
  const { type = 'date' } = options;
  const { format } = getDateFormat(type);

  return getPatternUtil(format);
}

const DateFormatter: Formatter<string, DateFormatterOptions> = {
  format,
  parse,
  validate,
  getPattern,
};

export default registerFormatter('date', DateFormatter);
